<template>
  <div class="dropdown-type" :class="inputClasses">
      <select class="droplist_layout" v-model="inputValue" :class="inputClasses">
						<option value="null" disabled>{{__(label)}}</option>
						<option
							v-for="item in valueListValues"
							:key="item.id"
							:value="item.id"
						>{{item.name}}</option>
					</select>
    <div class="error-message" v-if="errorMsg">{{errorMsg}}</div>
  </div>
</template>

<script>
import BMWMixin from "../BMWMixin";
export default {
  mixins: [BMWMixin],
  props: {
    label: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: ""
    },
    processing: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: "text"
    },
    isValid: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    valueList: {
      type: Array,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    min: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasFocus: null,
      inputValue: this.value
    };
  },
  computed: {
    valueListValues() {
      return this.valueList;
    },
    inputClasses() {
      let res = "is-invalid";
      if (!this.isInvalid) res = "is-valid";
     
      return res;
    }
  },
  watch: {
    value() {
      this.inputValue = this.value;
    },
    inputValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>


<style scoped>
.is-invalid {
  border-color: red;
}
.is-valid {
  border-color: black;
}

.text_label{
	margin: 5em	
}

.error-message{
		flex: 2;
		width: 100%;
		font-size: 12px;
		color: #ff4e2b;
		font-style: italic;
	}


  .droplist_layout {
	width: 100%;
	height: 40px;
	border: 1px solid #ced4da;
	color: #262625;
	font-size: 14px;
}
</style>
